<template>
<List
  @onFetchMore="updateItems"
  model="pony"
  :heading="heading"
  :description="description"
  :items="ponies"
  :status="status"
  :nextUrl="nextUrl"
  :displayStyle="displayStyle"
>
  <template #filter>
    <p>Total: {{total}} {{plural('pony', total)}}</p>
    <button
      class="elr-button elr-button-primary"
      @click="toggleFilters"
      aria-haspopup="true"
      aria-controls="color-filter-modal"
    >{{showFilters ? 'Hide' : 'Show'}} Colors</button>
    <transition name="fade">
      <ModalWindow
        modalId="colo-filter-modal"
        heading="Filter Ponies:"
        v-if="showFilters"
        @cancel="hideFilters"
        @close="hideFilters"
        @confirm="applyFilters"
      >
        <FilterList
          @updated="updateFilters"
          title="Colors"
          field="bodyColorId"
          :items="bodyColors"
          :filters="filters.bodyColorId"
        />
      </ModalWindow>
        <!-- <FilterList
          @updated="updateFilters"
          title="Poses"
          field="poseId"
          :items="poses"
          :filters="filters.poseId"
        />
        <FilterList
          @updated="updateFilters"
          title="Species"
          field="moldId"
          :items="molds"
          :filters="filters.moldId"
        />
        <FilterList
          @updated="updateFilters"
          title="Themes"
          field="themeId"
          :items="themes"
          :filters="filters.themeId"
        /> -->
    </transition>
    <ViewToggle :displayStyle="displayStyle" @toggled="toggleDisplayStyle" />
    <div class="button-holder sort-list" v-if="sorts && sorts.length">
      <SortToggle
        v-for="sort in sorts"
        :key="sort.field"
        :field="sort.field"
        :activeField="activeSort.field"
        :direction="sort.direction"
        :buttonLabel="sort.label"
        @sorted="toggleSort"
      />
    </div>
  </template>
  <template #list>
    <ul class="item-list">
      <ItemListHeader>
        <span>Name:</span>
        <span>Grouping:</span>
        <span>Mold:</span>
        <span>Pose:</span>
        <span>Color:</span>
        <span>Collected:</span>
        <span>Wishlisted:</span>
        <!-- <span>Loved:</span> -->
        <span>Average Price:</span>
      </ItemListHeader>
      <ListItem
        @removed="removeItem"
        :key="item.id"
        v-for="item in ponies"
        :item="item"
        :user="user"
        model="pony"
        :url="url(item.id)"
      >
        <span><router-link :to="`/pony/${item.id}`">{{item.name}}</router-link></span>
        <span>{{item.grouping.name}}</span>
        <span>{{item.mold.name}}</span>
        <span>{{item.pose.name}}</span>
        <span>{{item.body_color.name}}</span>
        <span>{{item.collected}}</span>
        <span>{{item.wishlisted}}</span>
        <!-- <span>{{item.favorited}}</span> -->
        <span>{{currency(item.averagePrice)}}</span>
      </ListItem>
    </ul>
  </template>
  <PonyCard
    :key="item.id"
    v-for="item in ponies"
    :user="user"
    :authenticated="authenticated"
    :item="item"
    :url="url(item.id)"
    @removed="removeItem"
  />
</List>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import List from '../../layouts/List/List';
import PonyCard from '../../components/PonyCard/PonyCard';
import FilterList from '../../components/FilterList/FilterList';
import { currency, plural } from '../../utils/helpers';
import ViewToggle from '../../components/ViewToggle/ViewToggle';
import ListItem from '../../components/ListItem/ListItem';
import SortToggle from '../../components/SortToggle/SortToggle';
import ItemListHeader from '../../components/ItemListHeader/ItemListHeader';
import ModalWindow from '../../components/ModalWindow/ModalWindow';

export default {
  name: 'PonyList',
  data() {
    return {
      errors: [],
      pendingFilters: [],
      showFilters: false,
    };
  },
  components: {
    PonyCard,
    List,
    FilterList,
    ItemListHeader,
    ListItem,
    SortToggle,
    ViewToggle,
    ModalWindow
  },
  mounted() {
    this.CLEAR_FILTERS({num: this.num});
    this.$store.dispatch('bodyColor/FETCH_ALL', {
      num: -1
    });
    this.$store.dispatch('pose/FETCH_ALL', {
      num: -1
    });
    this.$store.dispatch('mold/FETCH_ALL', {
      num: -1
    });
    this.$store.dispatch('theme/FETCH_ALL', {
      num: -1
    });
  },
  computed: {
    ...mapState({
      user: state => state.currentUser.currentUser,
      authenticated: state => state.currentUser.authenticated,
      heading: state => state.pony.heading,
      description: state => state.pony.description,
      status: state => state.pony.status,
      nextUrl: state => state.pony.nextUrl,
      displayStyle: state => state.pony.displayStyle,
      total: state => state.pony.total,
      sorts: state => state.pony.sorts,
      activeSort: state => state.pony.sorts.filter(o => o.active)[0],
      num: state => state.pony.num
    }),
    ponies() {
      return this.$store.getters['pony/getAll'];
    },
    bodyColors() {
      return this.$store.getters['bodyColor/getAll'];
    },
    molds() {
      return this.$store.getters['mold/getAll'];
    },
    themes() {
      return this.$store.getters['theme/getAll'];
    },
    poses() {
      return this.$store.getters['pose/getAll'];
    },
    filters() {
      return this.$store.getters['pony/getFilters']();
    }
  },
  methods: {
    ...mapActions('pony', [
      'CLEAR_FILTERS',
      'UPDATE_FILTERS',
      'FETCH_MORE',
      'REMOVE',
      'CHANGE_DISPLAY_STYLE',
      'SORT'
    ]),
    toggleFilters() {
      this.showFilters = !this.showFilters;
    },
    hideFilters() {
      this.showFilters = false;
    },
    updateFilters(payload) {
      this.pendingFilters = payload;
      // console.log(this.pendingFilters);
    },
    applyFilters() {
      // send update filter action along with new filters
      this.UPDATE_FILTERS({
        name: this.pendingFilters.name,
        value: this.pendingFilters.filters
      });
      this.showFilters = false;
    },
    updateItems() {
      this.FETCH_MORE(this.filters);
    },
    removeItem({ id }) {
      this.REMOVE({ id });
    },
    url(id) {
      return `/pony/${id}`;
    },
    toggleDisplayStyle({ display }) {
      this.CHANGE_DISPLAY_STYLE({ display })
    },
    toggleSort({ direction, field }) {
      this.SORT({ direction, field });
    },
    currency,
    plural,
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/sass/_config.scss';

.item-list {
  margin: 0;
  padding: 0;
}

.button-holder {
  text-align: left;
  padding-top: 0;
  
  .sort-button {
    margin-right: 10px;
    width: auto;
  }
}
</style>
